function validationNotEmpty (textBlock, oldText, newText) {
  return newText.length > 0
}

export { validationNotEmpty }



// WEBPACK FOOTER //
// ./src/graph_parts/validation.js